import { render } from "./RotasRapida.vue?vue&type=template&id=e5f49638"
import script from "./RotasRapida.vue?vue&type=script&lang=js"
export * from "./RotasRapida.vue?vue&type=script&lang=js"

import "./RotasRapida.vue?vue&type=style&index=0&id=e5f49638&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__